module.exports = __webpack_public_path__ + "img/atalho-4.20c6aa54.png";